// import { Base64 }  from 'js-base64';

/*
  window.location.origin polyfill
 */

// for staging
export const rootApi =()=> {
  return "https://staging.sporthood.in"
}


export const getLocationOrigin = () => {
  // if (!window.location.origin) {
  //   window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
  // }

  // production
   return "https://api.sporthood.in/api/v1";
  
  // local
  // return "http://localhost:8000/api/v1";
  
  // return "http://127.0.0.1:8000/api/v1";
  // return rootApi()+"/api/v1"; // for staging api
};

/*
  query options:
 */
export const defaultOptions = {
  credentials: 'include'
};

export const postMethod = {
  method: 'POST'
};

export const jsonHeader = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
};

/*
  query response helpers:
 */
export const checkStatus = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  else if(response.status == 455){
    const error = new Error(response.statusText);
    error.message = "Cannot add data of last month. Please contact your Delivery Manager";
    error.status = response.status;
    return Promise.reject(error);
  }
  else {
    let body = null;
    try {
      body = await response.clone().json();
    } catch (e) {
      // non-JSON error body, fall back to statusText below
    }
    const error = new Error((body && (body.message || body.detail)) || response.statusText);
    error.response = response;
    error.status = response.status;
    error.body = body;
    // Present on both @ratelimit (Retry-After header only) and @backoff
    // (header + retry_after_seconds in the body) responses.
    const retryAfterHeader = response.headers.get('Retry-After');
    error.retryAfter = retryAfterHeader ? Number(retryAfterHeader) : (body && body.retry_after_seconds) || null;
    return Promise.reject(error);
  }
};

export const parseJSON = (response) => {
  console.log(response);
  return response.json();
};

/*
 general helpers
 */
export const encodeBase64 = (stringToEncode) => {
  return Base64.encode(stringToEncode);
};



// WEBPACK FOOTER //
// ./src/app/services/fetchTools.js